export const findAncestor = (el, cls) => {
  while ((el = el.parentElement) && !el.classList.contains(cls));
  return el;
}

export const scrollTo = (el) => {
  console.log(el)
  let headerOffset = 0,
      elementPosition = el.getBoundingClientRect().top,
      offsetPosition = elementPosition - headerOffset

  window.scrollTo(100, 100);
}